<template>
  <button
    :type="type"
    class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-25"
  >
    <slot></slot>
  </button>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'button',
    },
  },
});
</script>
